// extracted by mini-css-extract-plugin
export default {"content":"FeatureWrap_content__xAGNw","horizontal":"FeatureWrap_horizontal__V2j5U","feature":"FeatureWrap_feature__kdJcP","title":"FeatureWrap_title__bxFnV"};